import { isFunction } from "lodash";
import React, { Component } from "react";
import CheckboxMap from "./components/checkbox-map.js";
import argentina from "./maps/argentina.js";
import { Paper, FlatButton, RaisedButton } from "material-ui";
import { Card, CardHeader, CardText } from "material-ui/Card";

class MapaArgentina extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: {},
      reMap: null
		};
    this.handleFilter = this.handleFilter.bind(this);
    this.handleReset  = this.handleReset.bind(this);
	}

	handleFilter() {
		if (isFunction(this.props.onUpdate)) {
			this.props.onUpdate(this.state.selected);
		}
	}

  /*
   * Como el componente de mapas no esta controlado, lo desmonto y lo vuelvo a
   * montar para resetearlo
   */
  handleReset(){
    const self = this;
    this.setState({selected: [], reMap: true}, ()=>{
      self.handleFilter();
      self.setState({reMap:false})
    });
  }

	renderButtons() {
		return [
			<FlatButton
				key={"close"}
				label="Limpiar"
				primary={true}
				onClick={this.handleReset}
			/>,
			<RaisedButton
				key={"filtrar"}
				label="Filtrar"
				primary={true}
				keyboardFocused={true}
				onClick={this.handleFilter}
			/>
		];
	}

	renderCard(content) {
		const actions = this.renderButtons();
		const title = this.props.title;
		const style = this.props.style;
		let cardHeader = null;
		if (title !== null || title !== undefined) {
			cardHeader = (
				<CardHeader textStyle={{ paddingRight: 0, paddingLeft: 30 }}>
					{title}
				</CardHeader>
			);
		}
		return (
			<Card style={style}>
				{cardHeader}
				<CardText>
					{content}
					{actions}
				</CardText>
			</Card>
		);
	}

	renderPaper(content) {
		const actions = this.renderButtons();
		const title = this.props.title;
		const style = this.props.style;
		let header = null;
		if (title !== null || title !== undefined) {
			header = <div>{title}</div>;
		}
		return (
			<Paper style={style}>
				{header}
				{content}
				{actions}
			</Paper>
		);
	}

	render() {
    const onUpdate = selected => this.setState({ selected });
    let content = null;
    if(!this.state.reMap){
      content = (
  			<CheckboxMap
  				onUpdate={onUpdate}
  				map={argentina}
  				width={275}
  				clientX={10}
  				clientY={10}
  			/>
  		);
    }
		if (this.props.type === "card") {
			return this.renderCard(content);
		}
		if (this.props.type === "paper") {
			return this.renderPaper(content);
		}
		return content;
	}
}

export default MapaArgentina;



// WEBPACK FOOTER //
// ./src/components/SVGMaps/MapaArgentina.js